module.exports = __webpack_public_path__ + "img/house-circle-check.4eb8e85d.svg";